import styled from 'styled-components';

export default styled.span`
	max-width: 100%;
	* {
		line-height: 16px;
		size: 12px;
		padding: 2px;
	}
	.motif-chip {
		.motif-chip-button {
			max-width: 100%;
		}

		&.ey-tag,
		&.yellow {
			.motif-chip-button {
				border-color: ${(props) => props.theme.color[`yellow400`]};
			}
		}
		&.gray {
			.motif-chip-button {
				border-color: ${(props) => props.theme.color[`grey400`]};
			}
		}
		&.marron{
			.motif-chip-button {
				border-color: ${(props) => props.theme.color[`Maroon400`]};
			}
		},
		&.red {
			.motif-chip-button {
				border-color: ${(props) => props.theme.color[`red600`]};
			}
		}
		&.green {
			.motif-chip-button {
				border-color: ${(props) => props.theme.color[`green300`]};
			}
		}
		&.orange {
			.motif-chip-button {
				border-color: ${(props) => props.theme.color[`orange400`]};
			}
		}
		&.purple {
			.motif-chip-button {
				border-color: ${(props) => props.theme.color[`purple200`]};
			}
		}
		&.blue {
			.motif-chip-button {
				border-color: ${(props) => props.theme.color[`blue400`]};
			}
		}
		&.teal {
			.motif-chip-button {
				border-color: ${(props) => props.theme.color[`teal400`]};
			}
		}
		&.bg.blue-transparent {
			.motif-chip-button {
				background: linear-gradient(0deg, rgba(21, 92, 180, 0.1), rgba(21, 92, 180, 0.1)),
					${(props) => props.theme.color[`white`]};
				padding: 3px;
				border-width: 0px;
			}
		}
	}
`;
